import { render, staticRenderFns } from "./legacier.vue?vue&type=template&id=6d71fc8b&"
import script from "./legacier.vue?vue&type=script&lang=js&"
export * from "./legacier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports